import { ChangeDetectorRef, Component } from '@angular/core';
import {IEntityListComponentMembers, IEntityListDynamicCellComponentGeneric } from '@mt-ng2/entity-list-module';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { ModalService } from '@mt-ng2/modal-module';
import { IOrder } from '../../model/interfaces/order';
import { OrderService } from '../order.service';
import { ClaimsService, ClaimValues } from '@mt-ng2/auth-module';
import { ClaimTypes } from '../../model/ClaimTypes';

@Component({
    template: `
        <ng-container>
            <i *ngIf="!entity.Archived" title="archive" (click)="showModal($event)" class="fa fa-2x fa-fw fa-trash icon-main"></i>
            <i *ngIf="entity.Archived" title="un-archive" (click)="showModal($event)" class="fa fa-2x fa-fw fa-unlock icon-main"></i>
        </ng-container>
    `,
    standalone: false
})
export class ArchiveOrderModalComponent implements IEntityListDynamicCellComponentGeneric<IOrder> {
    entityListComponentMembers: IEntityListComponentMembers;
    entity: IOrder;

    constructor(
        private claimsService: ClaimsService,
        private modalService: ModalService,
        private orderService: OrderService,
        private notificationsService: NotificationsService,
        private cdr: ChangeDetectorRef
    ) { }

    showModal(event: PointerEvent): void {
        event.stopImmediatePropagation();

        const hasFullAccessToOrders: boolean = this.claimsService.hasClaim(ClaimTypes.Orders, [ClaimValues.FullAccess]);
        if (!hasFullAccessToOrders) {
            return;
        }

        const archived = this.entity['Archived'] ? 1 : 0;
        this.modalService
            .showModal({
                confirmButtonText: 'Yes',
                inputValue: archived,
                icon: 'warning',
                showCancelButton: true,
                text: `Are you sure you want to ${this.entity.Archived ? 'restore' : 'archive'} this order?`,
                title: '',
            })
            .subscribe((result) => {
                if (result.isConfirmed) {
                    this.orderService.updateArchivedForOrder(this.entity.Id)
                        .subscribe(() => {
                            this.orderService.orderUpdatedSubject.next();
                            this.notificationsService.success('Successfully updated archive status.');
                        });
                }
            });
    }
}
